import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as ToastSonner } from '@/components/ui/sonner';
import DemoPage from '@/pages/DemoPage';
import DocsPage from '@/pages/DocsPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import UserLogin from '@/pages/UserLogin';
import UserRegister from '@/pages/UserRegister';
import DetailTracking from '@/pages/DetailTracking';
import SampleTracking from '@/pages/SampleTracking';
import UserDashboard from '@/pages/UserDashboard';
import { AuthProvider } from '@/hooks/use-auth';
import ProtectedRoute from './middlewares/ProtectedRoute';
import PublicRoute from './middlewares/PublicRoute';
import AdminProtectedRoute from './middlewares/AdminProtectedRoute';
import AdminPublicRoute from './middlewares/AdminPublicRoute';

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B]">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/" element={<DemoPage />} />
              <Route path="/login" element={<UserLogin />} />
              <Route path="/register" element={<UserRegister />} />
            </Route>
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/track" element={<DetailTracking />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/dashboard/statistic/:id" element={<DetailTracking />} />
            </Route>
            <Route path="/sample-tracking" element={<SampleTracking />} />
            <Route element={<AdminPublicRoute />}>
              <Route path="/admin/login" element={<AdminLogin />} />
            </Route>
            <Route element={<AdminProtectedRoute />}>
              <Route path="/admin" element={<AdminDashboard />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <ToastSonner position="top-center" duration={3000} richColors />
      <div className="noise-overlay" />
    </div>
  );
}

export default App;
